import styled from 'styled-components';

export const Record = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin-top: 8px;
  background-color: #fff;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 53px;
  border-bottom: 1px solid #f2f2f2;
  h2 {
    margin-left: 15px;
    font-size: 14px;
    color: #151515;
  }
`;

export const HeaderNonBorder = styled.div`
  display: flex;
  align-items: center;
  height: 53px;
  h2 {
    margin-left: 15px;
    font-size: 14px;
    color: #151515;
  }
`;

export const ChartDataContents = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const ChartDataPlayer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChartDataImage = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;

  img {
    width: 60px;
    height: 60px;
  }
`;

export const ChartDataInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  span {
    height: 12px;
    margin-bottom: 7px;
    line-height: 12px;
    font-size: 10px;
    color: #999999;

    &:first-child {
      font-size: 14px;
      color: #000;
    }

    &:nth-child(2) {
      margin-bottom: 4px;
    }

    &:last-child {
      margin-bottom: none;
    }
  }
`;

export const VsSquare = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  /* margin-top: 40px; */
  background-color: #f1f2f4;
  transform: rotate(45deg);

  span {
    transform: rotate(-45deg);
    font-size: 14px;
    font-weight: 300;
    color: #999999;
  }
`;

export const ChartContents = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 0px 15px;

  li {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 19px;

    &:last-child {
      margin-bottom: none;
    }
  }
`;

export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 7px;

  span {
    font-size: 15px;
    font-weight: 300;
    color: #222222;
  }

  span:nth-child(2) {
    font-size: 10px;
    font-weight: normal;
    color: #666666;
  }

  /* div {
    flex: 1;
  } */
`;

export const ChartArea = styled.div`
  display: flex;
  height: 5px;
  width: 100%;

  div {
    flex: 1;
  }
`;

export const ChartDivider = styled.div`
  height: 100%;
  width: 1px;
  max-width: 1px;
  background-color: #fff;
`;

export const Tab = styled.div`
  box-sizing: border-box;
  display: flex;
  // height: 74px;
  width: 100%;
  margin-top: 8px;
  padding: 20px 15px;
  background-color: #ffffff;
`;

export const Button = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  border: solid 1px #78818e;
  background-color: #ffffff;
  font-size: 13px;
  &.active {
    background-color: #78818e;
    color: #ffffff;
  }
`;
